import firebase from "firebase";
import 'firebase/firestore';
import 'firebase/functions';
const firebaseConfig = {
  apiKey: "AIzaSyDZ36ftVAxaj71sVUcz01zAWTn6KK5o4zU",
  authDomain: "reactive-solutions-e40ba.firebaseapp.com",
  databaseURL: "https://reactive-solutions-e40ba-default-rtdb.firebaseio.com/",
  projectId: "reactive-solutions-e40ba",
  storageBucket: "reactive-solutions-e40ba.appspot.com",
  messagingSenderId: "383779302371",
  appId: "1:383779302371:web:d708177815e61ffd60ced6"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

  const storage = firebaseApp.storage()
  const storageRef = storage.ref()
  let urls = {
    imgx418x300: storageRef.child('perfected-webapps-418x300.png').getDownloadURL(), 
    imgx557x400: storageRef.child('perfected-webapps-557x400.png').getDownloadURL(),
    img: storageRef.child('perfected-webapps.png').getDownloadURL()
  };
  const firebaseServices = {
      db: firebaseApp.firestore(),
      functions: firebaseApp.functions(),
      dlurls: urls,
  }
  
  
  export { firebaseServices };